module.exports = {"cognito":{"poolId":"us-east-1:a491003a-1d9b-4c7b-9d61-36ecf5d4f637"},"lex":{"botName":"oneMinMe","botAlias":"prodBot","initialText":"","initialSpeechInstruction":""},"polly":{"voiceId":"Salli"},"ui":{"parentOrigin":"http://localhost:8080","pageTitle":"Your friendly conversational bot.","toolbarTitle":"1-min Me: conversations for YOU."},"recorder":{"preset":"speech_recognition"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/config.prod.json
// module id = dm3o
// module chunks = 1